import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";

import { Box, Popover } from "@mui/material";

import HrchyLevelSegments from "@plannel/components/ui/HrchyLevelSegments";

// 서버가 주는 계층 그룹({ grpCd, grpName })을 HrchyLevelSegments 가 받는 { id, name } 으로 맞춘다
const toOptions = groups => (groups ?? []).map(g => ({ id: g.grpCd, name: g.grpName }));

const HrchyGroupModal = props => {
  const { t, open, setOpen, anchorEl, setAnchorEl, close, custGrpLevel, itemGrpLevel, selectCHG, selectIHG } = props;

  const [custHrchyGrp, setCustHrchyGrp] = useState(selectCHG);
  const [itemHrchyGrp, setItemHrchyGrp] = useState(selectIHG);

  const handleClose = () => {
    const hrchyGroups = { chg: custHrchyGrp, ihg: itemHrchyGrp };
    close(hrchyGroups);
    setAnchorEl(null);
    setOpen(false);
  };

  // SegmentedControl 은 값을 그대로 넘긴다(라디오의 event 객체가 아니다)
  const handleItemClick = grpCd => setItemHrchyGrp(grpCd);
  const handleCustClick = grpCd => setCustHrchyGrp(grpCd);

  useEffect(() => {
    if (selectCHG) {
      setCustHrchyGrp(selectCHG ?? custGrpLevel?.[0].grpCd);
    }
    if (selectIHG) {
      setItemHrchyGrp(selectIHG ?? itemGrpLevel?.[0].grpCd);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCHG, selectIHG])

  return (
    <Box sx={{ maxHeight: "300px", paddingLeft: "10px", paddoverflowY: "auto" }}>
      <Popover
        id={open ? "hrchy-popover" : undefined}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        {/*
          두 축(거래처·품목) 모두 **배타선택**이라 토큰 알약이 아니라 세그먼트다.
          (프로젝트 규칙: 배타선택=SegmentedControl, 복수선택=토큰/체크박스 —
           components/ui/HrchyLevelSegments.js 주석 참고)
          세로로 쌓아 구역 제목 + 세그먼트가 한 덩어리로 읽히게 한다. 옛 가로 배치는
          두 라디오 목록 사이에 세로 divider 를 둬서 축이 나뉜 걸 알아보기 어려웠다.
        */}
        <Box sx={{ p: 2, minWidth: 240, display: "flex", flexDirection: "column", gap: 2 }}>
          {custGrpLevel && (
            <HrchyLevelSegments
              label={t("customerHrchyGroup")}
              levels={toOptions(custGrpLevel)}
              value={custHrchyGrp}
              onChange={handleCustClick}
            />
          )}
          {itemGrpLevel && (
            <HrchyLevelSegments
              label={t("itemHrchyGroup")}
              levels={toOptions(itemGrpLevel)}
              value={itemHrchyGrp}
              onChange={handleItemClick}
            />
          )}
        </Box>
      </Popover>
    </Box>
  );
};

export default withTranslation()(HrchyGroupModal);
